import React from 'react';

type Props = {
  children?: React.ReactNode;
};
const Contents = ({children}: Props) => (
  <div className="text-left">{children}</div>
);

export default Contents;
